/**
 * @file Reads the scope level the server refused from the Analytics page's
 * `location.state`, which the `forbiddenLevel` fallback sets as
 * `{ refusedLevel }` when it replaces the URL's scope with `self`. Consumer:
 * the page shell's forbidden notice. Any other state, including none, is
 * `undefined`, so the next view change, which passes no state, clears it.
 */
import { ANALYTICS_SCOPE_LEVELS } from '#types';
import type { AnalyticsScopeLevel } from '#types';

export const analyticsRefusedLevel = (
  locationState: unknown,
): AnalyticsScopeLevel | undefined =>
  typeof locationState === 'object' &&
  locationState !== null &&
  'refusedLevel' in locationState
    ? ANALYTICS_SCOPE_LEVELS.find(
        (level) => level === locationState.refusedLevel,
      )
    : undefined;
